import { UploadNewsRequest, AdminGetCarouselByPageRequest, AdminLoginRequest, BaseRequest, ByIdRequest, GetNewsListRequest, SaveProductTypeRequest, GetProductsRequest, AddProductRequest, GetProductByTypeRequest, GetSomeProductTypesRequest, SearchProductByNameRequest } from "@/typeDefine/HttpRequestType";
import { AdminDataResponse, AdminGetCarouselByPageResponse, BaseResponse, CarouselList, GetHotProductResponse, GetNewsDetailsResponse, GetNewsListResponse, GetProductByTypeResponse, GetProductDetailsByIdResponse, GetProductsResponse, GetProductTypesResponse, GetSomeProductTypesResponse, RoutersResponse, SearchProductByNameResponse } from "@/typeDefine/HttpResponseType";
import { IApi } from "@/typeDefine/IApi";
import { Requests } from "./Requests";

export class Api implements IApi {

    public static readonly instance: Api = new Api()

    private constructor() { }

    public getRouters(): Promise<RoutersResponse> {
        return Requests.instance.get({
            url: '/router/queryAll',
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public getAdminData(): Promise<AdminDataResponse> {
        return Requests.instance.get({
            url: '/admin/getAdminData',
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public adminLogin(param: AdminLoginRequest): Promise<BaseResponse> {
        return Requests.instance.post({
            url: '/admin/login',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public adminGetCarouselByPage(param: AdminGetCarouselByPageRequest): Promise<AdminGetCarouselByPageResponse> {
        return Requests.instance.get({
            url: '/carousel/admin/getCarouselByPage',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public adminDeleteCarousel(param: ByIdRequest): Promise<BaseResponse> {
        return Requests.instance.delete({
            url: '/carousel/admin/delete',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public getAllCarousel(): Promise<CarouselList> {
        return Requests.instance.get({
            url: '/carousel/queryAll',
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public getNewsListByPage(param: GetNewsListRequest): Promise<GetNewsListResponse> {
        return Requests.instance.get({
            url: '/news/getNewsListByPage',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public getNewsDetails(param: ByIdRequest): Promise<GetNewsDetailsResponse> {
        return Requests.instance.get({
            url: '/news/getNewsDetails',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public addNews(param: UploadNewsRequest): Promise<BaseResponse> {
        return Requests.instance.post({
            url: '/news/admin/add',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public deleteNews(param: ByIdRequest): Promise<BaseResponse> {
        return Requests.instance.delete({
            url: '/news/admin/delete',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public updateNews(param: UploadNewsRequest): Promise<BaseResponse> {
        return Requests.instance.put({
            url: '/news/admin/update',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public getProductTypes(): Promise<GetProductTypesResponse> {
        return Requests.instance.get({
            url: '/product/type/getProductTypes',
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public saveProductType(param: SaveProductTypeRequest): Promise<BaseResponse> {
        return Requests.instance.put({
            url: '/product/type/admin/saveProductType',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public getProductByPage(param: GetProductsRequest): Promise<GetProductsResponse> {
        return Requests.instance.get({
            url: '/product/admin/getProductByPage',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public addProduct(param: AddProductRequest): Promise<BaseResponse> {
        return Requests.instance.post({
            url: '/product/admin/addProduct',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public deleteProduct(param: ByIdRequest): Promise<BaseResponse> {
        return Requests.instance.delete({
            url: '/product/admin/deleteProduct',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public getProductByType(param: GetProductByTypeRequest): Promise<GetProductByTypeResponse> {
        return Requests.instance.get({
            url: '/product/getProductByType',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public updateProduct(param: AddProductRequest & ByIdRequest): Promise<BaseResponse> {
        return Requests.instance.put({
            url: '/product/updateProduct',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public getProductDetailsById(param: ByIdRequest): Promise<GetProductDetailsByIdResponse> {
        return Requests.instance.get({
            url: '/product/getProductDetailsById',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public getHotProductList(): Promise<GetHotProductResponse> {
        return Requests.instance.get({
            url: '/product/getHotProduct',
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public getSomeProductTypes(param: GetSomeProductTypesRequest): Promise<GetSomeProductTypesResponse> {
        return Requests.instance.get({
            url: '/product/type/getSomeProductType',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }

    public searchProductByName(param: SearchProductByNameRequest): Promise<SearchProductByNameResponse> {
        return Requests.instance.get({
            url: '/product/searchProduct',
            param,
            header: {
                'content-type': 'application/json;charset=UTF-8'
            }
        })
    }
}